module.exports = __webpack_public_path__ + "img/icon-star-light-blue.16148db0.svg";